/* eslint-disable */
require('./alarm')
require('./all')
require('./bell-line')
require('./bell')
require('./breakdown')
require('./briefcase')
require('./camera')
require('./cancel_fullscreen')
require('./cog')
require('./contract')
require('./date-left')
require('./date-legend')
require('./date-right')
require('./device_dingwei')
require('./device_explain')
require('./device_guanli')
require('./device_GUZHANG')
require('./device_xiangqing')
require('./device_xiaofangrenwuguanli')
require('./device_yunweipeizhi')
require('./device_YUNXING')
require('./device_zhengchang')
require('./device_zhongduanpeizhi')
require('./diamond')
require('./display_contract')
require('./display_elevator')
require('./display_fault')
require('./display_life')
require('./display_maintain')
require('./display_message')
require('./display_monitor')
require('./display_number')
require('./display_record')
require('./display_yearly')
require('./doc')
require('./download')
require('./edit')
require('./estate')
require('./fullscreen')
require('./gh_info')
require('./imgEscalator')
require('./imgLift')
require('./indicatorsArrow')
require('./intercom')
require('./issue')
require('./jianshi')
require('./lang_switch')
require('./lar-change')
require('./lift')
require('./lift2')
require('./location')
require('./lock')
require('./login-query')
require('./map')
require('./map2')
require('./menu')
require('./monitor')
require('./msg_recept')
require('./msg')
require('./nianjian')
require('./page')
require('./pause')
require('./people')
require('./pie')
require('./play')
require('./playback')
require('./r-edit')
require('./r-info')
require('./remote')
require('./repair')
require('./report')
require('./ribao')
require('./run')
require('./s_package')
require('./s-await')
require('./s-forbidden')
require('./s-maintain')
require('./s-normal')
require('./screen_add')
require('./screen_current')
require('./screen_list')
require('./screen_monitor')
require('./screen_report')
require('./screen_run')
require('./screen_shield')
require('./screen_time')
require('./screen_wrench')
require('./screen')
require('./search')
require('./shield')
require('./sound_close')
require('./sound')
require('./state_escalator')
require('./state_lift')
require('./stop')
require('./thermometer')
require('./tiring')
require('./user-line')
require('./warning')
require('./wrench')
require('./yuebao')
require('./zhoubao')
